// v-rise: fades an element up once it scrolls into view. v-rise="2" staggers it by two steps.
let observer;

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('in'); observer.unobserve(e.target); }
      });
    }, { threshold: 0.01 });
  }
  return observer;
}

export const motionSupported = typeof window !== 'undefined' && 'IntersectionObserver' in window;

export default {
  mounted(el, binding) {
    if (!motionSupported) return;
    if (binding.value != null) el.style.setProperty('--r', binding.value);
    el.classList.add('rise');
    getObserver().observe(el);
  },
  unmounted(el) {
    if (observer) observer.unobserve(el);
  },
};
